
interface Number
{
	getIntegerPart(): number;
	getDecimalPart(): number;
	toDecimalString(decimals: number): string;
	toCurrencyString(decimals?: number): string;
	toNumberString(decimals?: number, milesSeparator?: boolean): string;
	toPercentageString(decimals?: number): string;
	round(decimals?: number, webApiForPrecision?: boolean): number;
}

interface NumberConstructor
{
	isInteger(value: number): boolean;
}

Number.isInteger = function (value: number): boolean
{
	return parseInt(String(value), 10) >= 0;
}

Number.prototype.getIntegerPart = function (): number
{
	return Math.trunc(this as number);
}

Number.prototype.getDecimalPart = function (): number
{
	return Math.abs(this as number - this.getIntegerPart());
}

Number.prototype.toDecimalString = function (decimals: number): string
{
	let rounded = this.round(decimals);

	let intPart = rounded.getIntegerPart().toString();
	let intPartWithPoints = "";

	let points = Math.trunc((intPart.length - 1) / 3);
	let pointsUsed = 0;
	for (let i = 0; i < intPart.length + points; i++)
	{
		if (i % 4 == 3)
		{
			intPartWithPoints = "." + intPartWithPoints;
			pointsUsed++;
		} else
		{
			intPartWithPoints = intPart[intPart.length - i + pointsUsed - 1] + intPartWithPoints;
		}
	}

	let decNum = Math.round(rounded.getDecimalPart() * 100) / 100;
	let decPart = decNum.toString();
	decPart = decPart.substr(2, decimals);
	while (decPart.length < 2)
		decPart += "0";

	return intPartWithPoints + "," + decPart;
}

Number.prototype.toNumberString = function (decimals?: number, milesSeparator?: boolean): string
{
	const formatter = new Intl.NumberFormat("it-IT"/*navigator.language*/,
		{
			minimumFractionDigits: decimals,
			maximumFractionDigits: decimals,
			useGrouping: (milesSeparator != null) ? milesSeparator : true
		});
	return formatter.format(Number(this));
}

Number.prototype.toCurrencyString = function (decimals?: number): string
{
	const formatter = new Intl.NumberFormat("it-IT"/*navigator.language*/,
		{
			style: "currency",
			currency: "EUR",
			minimumFractionDigits: (decimals != null) ? decimals : 2,
			maximumFractionDigits: (decimals != null) ? decimals : 2
		});
	return formatter.format(Number(this));
}

Number.prototype.toPercentageString = function (decimals?: number): string
{
	const formatter = new Intl.NumberFormat("it-IT"/*navigator.language*/,
		{
			style: "percent",
			minimumFractionDigits: (decimals != null) ? decimals : 2,
			maximumFractionDigits: (decimals != null) ? decimals : 2
		});
	return formatter.format(Number(this));
}

Number.prototype.round = function (decimals: number = 2, webApiForPrecision = false): number
{
	if (!webApiForPrecision)
	{
		let pow = Math.pow(10, decimals);
		return Math.round((this as number) * pow) / pow;
	}
	else
	{
		let request: any = {}
		request.value = this;
		request.decimals = decimals;
		request.AuthKey = "10(P9m+U3a@Mtt-Oeo";

		let json = JSON.stringify(request);
		let roundedValue: number = NaN;
		$.ajax({
			async: false,
			contentType: "application/json",
			data: json,
			method: "POST",
			processData: false,
			url: "/api/UtilityWebApi/Round",
			success: (response: any) =>
			{
				if ((response as any).Success)
				{
					roundedValue = response.roundedValue;
				}
			}
		});
		return roundedValue;
	}
}
